import _styled from '@emotion/styled/base';
import Box from '@mui/material/Box';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';

const PreviewFileWrapper = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "eijct422"
} )(_ref => {
  return {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '8px'
  };
}, "" );
const StyledFileBox = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "eijct421"
} )(_ref2 => {
  return {
    borderRadius: 5,
    width: '150px',
    padding: 5,
    height: 40,
    border: '1px solid #e6e6e6',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer'
  };
}, "" );
const StyledCancelIcon = /*#__PURE__*/_styled(Box, {
  shouldForwardProp: isStyledPropsValid,
  target: "eijct420"
} )(_ref3 => {
  let {
    theme,
    sx
  } = _ref3;
  return {
    position: 'absolute',
    right: '-4px',
    top: '-4px',
    cursor: 'pointer',
    width: 'fit-content',
    height: '12px',
    borderRadius: '50%',
    color: theme.customColors.grey[600],
    backgroundColor: theme.customColors.grey[100],
    ...sx
  };
}, "" );

export { PreviewFileWrapper, StyledCancelIcon, StyledFileBox };
